import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to your My C's Tickets account",
    description:
      "Click Continue and connect your My C's account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your{" "}
        <Link
          target="_blank"
          href="https://mlb.tickets.com/?agency=VCAM_MYTIXX&orgid=57030#/auth/login"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          My C&apos;s Tickets
        </Link>{" "}
        account within 24 hours of purchase. Reach out to Live Fan Support for
        any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Black Friday Pack work?",
    description:
      "Start by adding your free Opening Night ticket to your cart. Opening Night is listed under Featured Games. You can then move on to choosing your 2 other games.",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "Yes, you must select all games, including Opening Night, at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout Rogers Field at Nat Bailey Stadium?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your{" "}
        <Link
          target="_blank"
          href="https://mlb.tickets.com/?agency=VCAM_MYTIXX&orgid=57030#/auth/login"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          My C&apos;s Tickets
        </Link>{" "}
        Account.
      </>
    ),
  },
];
